import { Button, styled, Theme } from '@material-ui/core';

export const StyledButtonLink = styled(Button)<Theme>(({ theme }) => ({
  textTransform: 'none',
  color: theme.palette.studyCard.accessibleBlue,
  fontWeight: 400,
  textDecoration: 'underline',
}));
